"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _elementUi = require("element-ui");

var _shortcuts = require("@/utils/shortcuts");

var _default2 = {
  name: 'DateRangePicker',
  mixins: [_elementUi.DatePicker],
  props: {
    type: {
      type: String,
      default: 'daterange'
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    defaultTime: {
      type: Array,
      default: function _default(_) {
        return ['00:00:00', '23:59:59'];
      }
    },
    pickerOptions: {
      type: _elementUi.DatePickerOptions,
      default: function _default(_) {
        return {
          shortcuts: _shortcuts.calendarShortcuts
        };
      }
    },
    size: {
      type: String,
      default: 'small'
    },
    rangeSeparator: {
      type: String,
      default: ':'
    },
    startPlaceholder: {
      type: String,
      default: '开始日期'
    },
    endPlaceholder: {
      type: String,
      default: '结束日期'
    }
  }
};
exports.default = _default2;